/**
 * Checkout-Zugang. Blockiert den Checkout für nicht freigeschaltete Kund:innen
 * (z. B. B2B-Login-Gate) und leitet stattdessen auf die Login-Seite um.
 */
(function () {
  'use strict';

  function readAccess() {
    if (window.coveraxCheckoutAccess) return window.coveraxCheckoutAccess;
    const node = document.getElementById('coverax-checkout-access');
    if (!node) return null;
    try {
      window.coveraxCheckoutAccess = JSON.parse(node.textContent || '{}');
      return window.coveraxCheckoutAccess;
    } catch (error) {
      return null;
    }
  }

  const access = readAccess() || {};

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const submitter = event.submitter;
      const checkoutButton =
        (submitter && submitter.name === 'checkout' && submitter) ||
        form.querySelector('[type="submit"][name="checkout"]');
      if (!checkoutButton) return;
      if (submitter && submitter.name !== 'checkout') return;

      if (access.allowCheckout === false && access.loginUrl) {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = access.loginUrl;
      }
    },
    true
  );
})();
